/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_RemoveInputs */

const en_us2_offline_kind_plan_remove = /** @type {(inputs: Offline_Kind_Plan_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise taken off the plan`)
};

const pt_br2_offline_kind_plan_remove = /** @type {(inputs: Offline_Kind_Plan_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício tirado do plano`)
};

const es_419_offline_kind_plan_remove = /** @type {(inputs: Offline_Kind_Plan_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicio quitado del plan`)
};

const pt_pt2_offline_kind_plan_remove = /** @type {(inputs: Offline_Kind_Plan_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício retirado do plano`)
};

const fr_fr2_offline_kind_plan_remove = /** @type {(inputs: Offline_Kind_Plan_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice retiré du programme`)
};

const de_de2_offline_kind_plan_remove = /** @type {(inputs: Offline_Kind_Plan_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung aus dem Plan entfernt`)
};

const it_it2_offline_kind_plan_remove = /** @type {(inputs: Offline_Kind_Plan_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizio tolto dalla scheda`)
};

/**
* | output |
* | --- |
* | "Exercise taken off the plan" |
*
* @param {Offline_Kind_Plan_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_remove = /** @type {((inputs?: Offline_Kind_Plan_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_remove(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_remove(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_remove(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_remove(inputs)
	return en_us2_offline_kind_plan_remove(inputs)
});
export { offline_kind_plan_remove as "offline.kind_plan_remove" }